// @flow strict

import * as React from 'react';
import cx from 'classnames';

type sizeType = {|
  width?: number,
  height?: number,
|};

type PropTypes = {|
  src: string,
  alt: string,
  className?: string,
  defaultSize: sizeType,
|};

const LazyLoadImage = (props: PropTypes) => (
  <img
    data-src={props.src}
    alt={props.alt}
    className={cx(['lazyload', props.className])}
    width={props.defaultSize.width}
    height={props.defaultSize.height}
  />
);

LazyLoadImage.defaultProps = {
  alt: '',
};

export default LazyLoadImage;
